import * as React from "react";
const SvgFiRrNotdef = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M16 0H8C5.24 0 3 2.24 3 5v14c0 2.76 2.24 5 5 5h8c2.76 0 5-2.24 5-5V5c0-2.76-2.24-5-5-5m-2.76 12 5.65-7.77c.07.25.11.5.11.77v14c0 .27-.05.52-.11.77zM16 2c.62 0 1.19.19 1.67.51L12 10.3 6.33 2.51C6.81 2.19 7.38 2 8 2zM5.11 19.77c-.07-.25-.11-.5-.11-.77V5c0-.27.05-.52.11-.77L10.76 12zM8 22c-.62 0-1.19-.19-1.67-.51L12 13.7l5.67 7.79c-.48.32-1.05.51-1.67.51z"
    />
  </svg>
);
export default SvgFiRrNotdef;
